/*
 * Copyright (c) 2024 Via Transportation, Inc. All rights reserved.
 *
 * This software is distributed under license and may not be used, copied,
 * modified, or distributed without the express written permission of
 * Via Transportation, Inc.
 */

import { makeStyles } from "@material-ui/core/styles";

export const useClasses = makeStyles((theme) => ({
    content: {
        padding: theme.spacing(2, 0),
        height: theme.spacing(21),
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
    },
}));
